import React from 'react';
import PropTypes from 'prop-types';

import { PlayerBadge } from '../..';

const DynamicPlayerBadge = ({ avatar, firstName, lastName, avatarBgColor, badgeSize })=> {
  return (avatar ?
    <img 
      className="dynamic-player-badge" 
      src={avatar} alt=""
      style={{ height: `${badgeSize}px`, width: `${badgeSize}px`, borderRadius: "50%" }}
    /> :
    <PlayerBadge 
      firstName={firstName} 
      lastName={lastName} 
      color={avatarBgColor} 
      fontSize={16}
      badgeSize={badgeSize}
    />
  );
};

DynamicPlayerBadge.propTypes = {
  avatar: PropTypes.string,
  avatarBgColor: PropTypes.string, 
  badgeSize: PropTypes.number, 
  firstName: PropTypes.string, 
  lastName: PropTypes.string
};

DynamicPlayerBadge.defaultProps = {
  avatar: "",
  avatarBgColor: "", 
  badgeSize: 50, 
  firstName: "", 
  lastName: ""
}

export default DynamicPlayerBadge;